/**
 * DstScrollUtils — shared scroll-position helpers for dst- custom sections.
 *
 * Loaded globally (theme.liquid, before section scripts) as `window.DstScrollUtils`.
 * Classic script, no ES module import/export — matches the rest of this theme's JS.
 */
window.DstScrollUtils = (() => {
  /**
   * ScrollGate — gates a rAF-throttled scroll callback behind an IntersectionObserver,
   * so continuous scroll-position math only runs while the element is near the
   * viewport. Used by anything that needs to track scroll progress through its own
   * height (e.g. dst-scroll-hero's frame scrub + chapter hold).
   */
  class ScrollGate {
    constructor(el, onScrollRAF, { rootMargin = '200px 0px' } = {}) {
      this._onScrollRAF = onScrollRAF;
      this._active = false;
      this._ticking = false;

      this._io = new IntersectionObserver(
        entries => { this._active = entries[0].isIntersecting; },
        { rootMargin }
      );
      this._io.observe(el);

      this._onScroll = () => {
        if (!this._active || this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(() => {
          this._onScrollRAF();
          this._ticking = false;
        });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    destroy() {
      this._io.disconnect();
      window.removeEventListener('scroll', this._onScroll);
    }
  }

  return { ScrollGate };
})();
